module.exports = __webpack_public_path__ + "static/one2car.0a64afeb.svg";